import React from 'react';

export default function Loader() {
  return (
    <div className="sdp-loader sdp-mt-4 sdp-mb-4">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
